import { useState, useEffect } from 'react';

const useTheme = () => {
    const getInitialTheme = () => {
        if (typeof window !== 'undefined' && window.matchMedia) {
            return window.matchMedia('(prefers-color-scheme: dark)').matches;
        }
        return false;
    };

    const [isDarkTheme, setIsDarkTheme] = useState(getInitialTheme());

    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const handleChange = (event: MediaQueryListEvent) => {
            setIsDarkTheme(event.matches);
        };

        mediaQuery.addEventListener('change', handleChange);
        return () => {
            mediaQuery.removeEventListener('change', handleChange);
        };
    }, []);

    return [isDarkTheme, setIsDarkTheme] as const;
};

export default useTheme;
